"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ChainLinkOracleFactory = /** @class */ (function (_super) {
    __extends(ChainLinkOracleFactory, _super);
    function ChainLinkOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ChainLinkOracleFactory.prototype.deploy = function (_priceFeed, overrides) {
        return _super.prototype.deploy.call(this, _priceFeed, overrides || {});
    };
    ChainLinkOracleFactory.prototype.getDeployTransaction = function (_priceFeed, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _priceFeed, overrides || {});
    };
    ChainLinkOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ChainLinkOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ChainLinkOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ChainLinkOracleFactory;
}(contracts_1.ContractFactory));
exports.ChainLinkOracleFactory = ChainLinkOracleFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_priceFeed",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "priceFeed",
        outputs: [
            {
                internalType: "contract AggregatorV3Interface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506040516102ba3803806102ba8339818101604052602081101561003357600080fd5b5051600080546001600160a01b0319166001600160a01b0380841691909117918290556040805163313ce56760e01b81529051929091169163313ce56791600480820192602092909190829003018186803b15801561009157600080fd5b505afa1580156100a5573d6000803e3d6000fd5b505050506040513d60208110156100bb57600080fd5b505160ff16600155506101e7806100d36000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c8063313ce56714610046578063741bef1a1461006057806396a0e5e314610084575b600080fd5b61004e6100a5565b60408051918252519081900360200190f35b6100686100ab565b604080516001600160a01b039092168252519081900360200190f35b61008c6100ba565b6040805192835260208301919091528051918290030190f35b60015481565b6000546001600160a01b031681565b6000806000806000809054906101000a90046001600160a01b03166001600160a01b031663feaf968c6040518163ffffffff1660e01b815260040160a06040518083038186803b15801561010d57600080fd5b505afa158015610121573d6000803e3d6000fd5b505050506040513d60a081101561013757600080fd5b5060208101516060909101519092509050600082136101875760405162461bcd60e51b81526004018080602001828103825260228152602001806101916022913960400191505060405180910390fd5b9092509050909156fe436861696e4c696e6b4f7261636c653a2070726963652077617320696e76616c6964a265627a7a7231582010126634b40c64e95b6c201851df86ae5993395a84dab3be1005804695a25ad564736f6c63430005100032";
